import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { SmsFormCover } from "../../../../../components/secondaryComponents/SmsCampaign";
import { BackButton } from "../../../../../components/primaryComponents";

const CreateSmsCampaign = () => {
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | SMS Campaign"
      description="Create SMS campaign"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          {/* <div className="d-flex align-items-center" style={{ gap: "10px" }}> */}
          <div>
            <BackButton />
          </div>

          <div>
            <h4 className="mb-0">SMS Campaign</h4>
            <p>
              Define the core details of your SMS campaign for internal tracking
            </p>
          </div>
          {/* </div> */}

          <SmsFormCover />
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default CreateSmsCampaign;
